import { Injectable } from "@angular/core";
import { AuthService } from 'src/app/core/services/auth.service';
import { ConfigService } from 'src/app/core/services/config.service';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { switchMap } from "rxjs/operators";
import { ResearchProposalDTO  } from "src/app/shared/models/ResearchProposalDTO";

@Injectable({ 
    providedIn: 'root'
})
export class ResearchProposalService {
    private readonly apiUrl = ConfigService.settings.urls.apiUrl;
    private baseurl = "/applicationresearchproposal/";
    private getSpecificUrl = this.apiUrl + this.baseurl + "byid/";    
    private updateUrl = this.apiUrl + this.baseurl + "update";
    private addUrl = this.apiUrl + this.baseurl + "add";    
        
    constructor(protected httpClient: HttpClient,
        protected authService: AuthService) { }

    public get(id: number): Observable<ResearchProposalDTO> {
        return this.httpClient.get<ResearchProposalDTO>(this.getSpecificUrl + id);
        // return this.httpClient.get<ResearchProposalDTO>(this.getSpecificUrl + id, { observe: 'response'}).pipe(
        //     switchMap(res => res.status === 200 ? of(res.body!) : of(undefined!))
        // );
    }

    public add(model: ResearchProposalDTO): Observable<ResearchProposalDTO> {
        return this.httpClient.post<ResearchProposalDTO>(this.addUrl, model);
    }

    public update(model: ResearchProposalDTO): Observable<ResearchProposalDTO> {
        return this.httpClient.post<ResearchProposalDTO>(this.updateUrl, model);
    }
}